import { render, staticRenderFns } from "./Markdown.vue?vue&type=template&id=4764cfea&scoped=true"
import script from "./Markdown.vue?vue&type=script&lang=js"
export * from "./Markdown.vue?vue&type=script&lang=js"
import style0 from "./Markdown.vue?vue&type=style&index=0&id=4764cfea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4764cfea",
  null
  
)

export default component.exports